export const createAlertAsyncModule = {
  importFn: () => import(/* webpackChunkName: "create-alert" */ './module-entry'),
  cacheKey: 'create-alert',
}
